import { VIEWPORT } from "@faire/help-center-utils/consts/eventEnum";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { Button } from "@faire/web--source/slate/Button";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { trackHelpCenterFaireLogoHeaderClick } from "@faire/web-api--source/events/helpCenter/click/faireLogoHeader";
import home from "@faire/web-api--source/routes/support";
import React from "react";
import styled from "styled-components";

interface IFaireLogoButtonProps {
  View: keyof typeof VIEWPORT;
  onClick?: () => void;
}

export const FaireLogoButton: React.FC<IFaireLogoButtonProps> = ({ View, onClick }) => {
  const retailerToken = getRetailerToken() ?? "";
  const brandToken = getBrandToken() ?? "";

  return (
    <FaireLogoWrapper
      onClick={() => {
        if (onClick) {
          onClick();
        } else {
          trackHelpCenterFaireLogoHeaderClick(retailerToken, brandToken, View);
        }
      }}
    >
      <Border>
        <FaireLogo size={88} />
      </Border>
    </FaireLogoWrapper>
  );
};
const FaireLogoWrapper = styled(Button).attrs({
  variant: "tertiary",
  linkTo: home(),
})`
  height: 50px;
`;

const Border = styled.div`
  height: 20px;
`;
